import { Box, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useEffect } from 'react'
import { NewCheckboxGrid } from '../../../components/NewCheckboxGrid'
import { useStores } from '../../../data/store'

interface CardsProps {
  type: string
  isEdit?: boolean
  entityId: string
}
const Cards = ({ type, isEdit }: CardsProps) => {
  const {
    updateCardsSelectionByType,
    cardsSelectDeselectAll,
    cardsColumnSelectionChange,
    cardsRowsSelectionChange,
    cardsIndividualCheckChange,
  } = useStores((root) => ({
    updateCardsSelectionByType: root.updateCardsSelectionByType,
    cardsSelectDeselectAll: root.cardsSelectDeselectAll,
    cardsColumnSelectionChange: root.cardsColumnSelectionChange,
    cardsRowsSelectionChange: root.cardsRowsSelectionChange,
    cardsIndividualCheckChange: root.cardsIndividualCheckChange,
    cardsLength: root.onboarding.cardList.length,
  }))

  const onHeaderSelectionChange = (item: any) => {
    updateCardsSelectionByType(item)
  }

  useEffect(() => {
    updateCardsSelectionByType({ id: '110', value: 'Debit Card' })
  }, [updateCardsSelectionByType])

  return (
    <Box f={1} overflow={'auto'} ph={40} pv={40} minHeight={600}>
      <Text
        title={'Select card type and schemes to provide access'}
        color={'BLACK_21'}
        fontSize={18}
        fontFamily={'jiotype-bold'}
      />
      <Spacer size={32} direction={'vertical'} />
      <ModBox w={'115%'} flex={1} overflowY={'auto'} paddingVertical={16} h={'100%'}>
        <NewCheckboxGrid
          onHeaderSelectionChange={onHeaderSelectionChange}
          isEditMode={isEdit}
          cardsSelectDeselectAll={cardsSelectDeselectAll}
          cardsColumnSelectionChange={cardsColumnSelectionChange}
          cardsRowsSelectionChange={cardsRowsSelectionChange}
          cardsIndividualCheckChange={cardsIndividualCheckChange}
        />
      </ModBox>
    </Box>
  )
}
export { Cards }
